import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { LightDangerouslyHtml } from '../common/fromAuth/LightDangerouslyHtml/LightDangerouslyHtml';
import PromoPopupButton from '../popup/PromoPopupButton';
import PromoSimplePopup from '../popup/PromoSimplePopup';

const PromoFieldLongTitlePopup = ({ popupRef = null, ...props }) => {
    return (
        <PromoSimplePopup text={<LightDangerouslyHtml dangerouslyHtml={props.info} />} popupRef={popupRef}>
            <PromoPopupButton iconName="check" text={props.morePopupButtonClose} onClick={() => popupRef.current?.close()} />
        </PromoSimplePopup>
    );
};

PromoFieldLongTitlePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => {
    return {
        morePopupButtonClose: state.messages.pageMessages.morePopupButtonClose,
    };
};

export default connect(mapStateToProps)(PromoFieldLongTitlePopup);
